// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_rattan_pyramid_type_a/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_rattan_pyramid_type_a: ModuleSchema = {
  "id": "core_rattan_pyramid_type_a",
  "uniqueId": "B3D_RPY1A",
  "createdAt": "2026-10-26T09:44:39.362Z",
  "updatedAt": "2026-10-27T08:51:40.672Z",
  "label": "Pyramid Type A",
  "description": "Structural interlocking Type A rattan strands wrapped around a truncated pyramid form.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "rattan",
    "type-a",
    "pyramid"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Pyramid Base Width",
      "min": 20,
      "max": 200,
      "default": 130,
      "step": 2,
      "unit": "mm"
    },
    {
      "key": "depth",
      "label": "Pyramid Base Depth",
      "min": 20,
      "max": 200,
      "default": 130,
      "step": 2,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Pyramid Height",
      "min": 12,
      "max": 160,
      "default": 80,
      "step": 2,
      "unit": "mm"
    },
    {
      "key": "pyramidTopScale",
      "label": "Truncated Top Scale",
      "min": 0.08,
      "max": 0.5,
      "default": 0.18,
      "step": 0.01,
      "unit": "ratio"
    },
    {
      "key": "wavePitch",
      "label": "Wave Pitch",
      "min": 1.5,
      "max": 24,
      "default": 6,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "waveAmplitude",
      "label": "Wave Amplitude",
      "min": 0,
      "max": 5,
      "default": 1,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "faceCycles",
      "label": "Odd Cycles Per Face",
      "min": 3,
      "max": 15,
      "default": 7,
      "step": 2,
      "unit": "cycles"
    },
    {
      "key": "layerOverlap",
      "label": "Structural Layer Overlap",
      "min": 0,
      "max": 1.6,
      "default": 0.3,
      "step": 0.05,
      "unit": "mm"
    },
    {
      "key": "strandThickness",
      "label": "Strand Thickness",
      "min": 0.2,
      "max": 10,
      "default": 1,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "strandHeight",
      "label": "Strand Height",
      "min": 0.4,
      "max": 10,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "padThickness",
      "label": "Structural Pad Thickness",
      "min": 0.2,
      "max": 10,
      "default": 3,
      "step": 0.1,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "pyramid_woven_body",
      "label": "Pyramid Interlocking Strands and Pad",
      "default": "#C08457",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "main_body",
      "label": "Rattan Pyramid Type A",
      "name": "Rattan Pyramid Type A",
      "color": "#C08457",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "pyramid_woven_body",
          "label": "Pyramid Interlocking Strands and Pad",
          "name": "Pyramid Interlocking Strands and Pad",
          "groupId": 0,
          "colorKey": "pyramid_woven_body",
          "defaultColor": "#C08457",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Pyramid Type A"
    }
  ]
};
